import { Routes } from '@angular/router';
import { middleOfficeGuard } from '@pages/middle-office';
import { languageReloadGuard, tunnelReferrerGuard } from '@pages/slug-page/guards';
import { slugPageResolver } from '@pages/slug-page/resolvers';

export const APP_ROUTES: Routes = [
  {
    path: 'middle',
    canActivate: [middleOfficeGuard],
    children: [],
  },
  {
    path: '**',
    canActivate: [languageReloadGuard, tunnelReferrerGuard],
    resolve: { pageData: slugPageResolver },
    loadComponent: () => import('@pages/slug-page').then((m) => m.SlugPageComponent),
  },
];
